import Config from "../constant/Config";
import { params } from "../utils";
import { deleteResource, fetchJsonIfOk } from "./ServiceUtils";

export const getEntries = async (roomId) => {
  return await fetchJsonIfOk(`${Config.apiurl}/entries?roomId=${roomId}`);
}

export const deleteEntry = async (entryId) => {
  return await deleteResource(`${Config.apiurl}/entry?${params({ entryId })}`);
}
